<template>
  <div class="data-group">
    <h3
      v-if="heading"
      class="data-group__heading"
    >{{ heading }}</h3>
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DataGroup',
    props: {
      heading: {
        required: false,
        type: String,
        default: null
      }
    }
  }
</script>

<style lang="scss">
  .data-group {
    &:not(:last-child) {
      padding-bottom: 30px;
    }

    &__heading {
      font-size: 20px;
      margin-bottom: 5px;
    }
  }
</style>
